import axios from "axios";
const jsonConfig = require("../../Config.json");

const teamMovement = async(payload) => {
    try
    {
        const response = await axios.post(
            jsonConfig.apiUrl + "teamMovementCheck",payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                }
            }
            
        );
        return Promise.resolve(response);
    }
    catch(error)
    {
        return Promise.reject(error);
    }
}

export default teamMovement